import React from 'react';
import PropTypes from 'prop-types';
import CCLRichText from '@deliveroo/consumer-component-library/components/RichText';

class RichText extends React.Component {
  componentDidMount() {
    if (!this.props.html) {
      throw new Error('Incorrect prop-types for Storyblok RichText component');
    }
  }

  render() {
    return (
      <CCLRichText spacing="medium 0">
        {/* this output is already sanitised by Storybook's markdown-html plugin */}
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: this.props.html }} />
      </CCLRichText>
    );
  }
}

RichText.propTypes = {
  html: PropTypes.string.isRequired,
};

export default RichText;
